
<div v-show="badgeCount > 0" class="badge-count">
  <span v-if="countable">{{ badgeCount | displayCount }}</span>
</div>
